import React from "react";
import { Camera, User, FileImage, ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";

const services = [
  {
    icon: Camera,
    title: "Cobertura Desportiva",
    desc: "Eventos, corridas, competições. Cobertura completa, entrega rápida, imagens prontas para imprensa e redes.",
    price: "Preço sob consulta",
    tag: "Eventos",
  },
  {
    icon: User,
    title: "Retratos Artísticos",
    desc: "Sessão individual a preto e branco. Editorial, dramático, autêntico. Inclui edição cinematográfica.",
    price: "€200 / sessão",
    tag: "Estúdio & Exterior",
  },
  {
    icon: FileImage,
    title: "Licenciamento de Imagens",
    desc: "Uso comercial, editorial ou publicitário. Arquivo curado com imagens originais a preto e branco.",
    price: "Preço sob consulta",
    tag: "Comercial",
  },
];

const Services = () => {
  const goContact = () => document.getElementById("contacto")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section
      id="servicos"
      className="bg-black py-24 md:py-32 border-t border-white/10"
      data-testid="services-section"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 lg:px-20">
        <Reveal>
          <div className="mb-14">
            <div className="flex items-center gap-3 mb-4">
              <span className="divider-red" />
              <span className="font-heading text-[#c0392b] tracking-[0.4em] text-xs uppercase">04 — Serviços</span>
            </div>
            <h2 className="font-heading text-white text-6xl md:text-8xl uppercase leading-[0.9]" data-testid="services-title">
              O Que<br />Ofereço
            </h2>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="services-grid">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.title} delay={i * 120}>
                <div className="service-card h-full flex flex-col" data-testid={`service-card-${i}`}>
                  <Icon className="text-white mb-8" size={36} strokeWidth={1.2} />
                  <div className="font-heading text-[#c0392b] tracking-[0.3em] text-xs uppercase mb-3">{s.tag}</div>
                  <h3 className="font-heading text-white text-3xl md:text-4xl uppercase leading-[1] mb-5">
                    {s.title}
                  </h3>
                  <p className="text-white/70 text-sm md:text-base leading-relaxed flex-1">{s.desc}</p>
                  <div className="mt-8 pt-6 border-t border-white/15 flex items-center justify-between">
                    <span className="font-heading text-white text-lg tracking-[0.1em]">{s.price}</span>
                    <button
                      onClick={goContact}
                      className="text-white hover:text-[#c0392b] transition-colors flex items-center gap-2 font-heading text-sm tracking-[0.25em] uppercase"
                      data-testid={`service-cta-${i}`}
                    >
                      Pedir <ArrowUpRight size={18} />
                    </button>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
